export default "__VITE_ASSET__DDTsYDsR__"